import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { SpeedOutlined as SpeedIcon } from '@material-ui/icons';
import { Metric } from '../types/metrics.types';
import { useMetricItemStyles } from '../styles/metric-item.styles';

interface MetricItemProps {
  metric: Metric;
}

export const MetricItem = React.memo<MetricItemProps>(({ metric }) => {
  const classes = useMetricItemStyles();
  
  return (
    <Box className={classes.container}>
      <Box className={classes.iconContainer}>
        <SpeedIcon className={classes.icon} />
      </Box>
      <Box>
        <Typography 
          variant="caption" 
          className={classes.metricName}
        >
          {metric.name}
        </Typography>
        <Typography 
          variant="h6" 
          className={classes.metricValue}
        >
          {metric.value}
        </Typography>
      </Box>
    </Box>
  );
});

MetricItem.displayName = 'MetricItem';
